(function (module) {
    "use strict";

    module.service('skuVolumeValueService', ['synchronousEventsBus', 'forecastCacheService', '$q', SkuVolumeValueService]);

    function SkuVolumeValueService(
        this: $TSFixMe,
        synchronousEventsBus: $TSFixMe,
        forecastCacheService: $TSFixMe,
        $q: ng.IQService
    ) {
        const service = this;

        service.onRegressionChange = (e: $TSFixMe, args: $TSFixMe) => {
            if (args.parameters.forecastMethod.methodId != 'sku') {
                return;
            }

            const forecast = args.forecast,
                parameters = args.parameters,
                market = forecastCacheService.getForecast().market;

            if (parameters.forecastType.typeId == 'volume') {
                return service.calculateBrandVolume(market, args.parameters);
            } else if (parameters.forecastType.typeId == 'value') {
                return service.calculateBrandValue(market, args.parameters);
            }

        };

        function sumArray(dest: $TSFixMe, source: $TSFixMe) {

            if (angular.isUndefinedOrNull(source) || source.length != dest.length) {
                return;
            }
            source.forEach((e: $TSFixMe, index: $TSFixMe) => { dest[index] += e; });
        }

        function initVolumeValueObject(pmForecast: $TSFixMe, statisticalForecast: $TSFixMe) {
            return {
                pmForecast: new Array(pmForecast.length).fill(0),
                statisticalForecast: new Array(statisticalForecast.length).fill(0)
            };
        }

        service.calculateBrandVolume = (market: $TSFixMe, parameters: $TSFixMe) => {
            var promises = [];
            for (const brand of market.brands) {
                brand.forecast = brand.forecast || {};
                brand.forecast.volume = initVolumeValueObject(market.forecast.pmForecast, market.forecast.statisticalForecast);

                for (const sku of brand.skus) {
                    if (sku.forecast && sku.forecast.pmForecast && sku.forecast.statisticalForecast) {
                        sumArray(brand.forecast.volume.pmForecast, sku.forecast.pmForecast);
                        sumArray(brand.forecast.volume.statisticalForecast, sku.forecast.statisticalForecast);
                    }
                    promises.push(synchronousEventsBus.$broadcast('sku.SkuVolumeCalculated', { forecast: market.forecast, parameters: parameters, brand: brand, sku: sku }));
                }
                promises.push(synchronousEventsBus.$broadcast('sku.BrandVolumeCalculated', { forecast: market.forecast, parameters: parameters, brand: brand }));
            }
            return $q.all(promises);
        }

        service.calculateBrandValue = (market: $TSFixMe, parameters: $TSFixMe) => {
            var promises = [];
            for (const brand of market.brands) {
                brand.forecast = brand.forecast || {};
                brand.forecast.value = initVolumeValueObject(market.forecast.pmForecast, market.forecast.statisticalForecast);

                for (const sku of brand.skus) {
                    if (sku.forecast && sku.forecast.pmForecast && sku.forecast.statisticalForecast) {
                        sumArray(brand.forecast.value.pmForecast, sku.forecast.pmForecast);
                        sumArray(brand.forecast.value.statisticalForecast, sku.forecast.statisticalForecast);
                    }
                }

                promises.push(synchronousEventsBus.$broadcast('sku.BrandValueCalculated', { forecast: market.forecast, parameters: parameters, brand: brand }));
            }
            return $q.all(promises);
        }

        service.calculateBrandValueBySkuChanges = (brand: $TSFixMe) => {

            let forecastLength = brand.forecast.volume.pmForecast.length;
            brand.forecast.value = { pmForecast: new Array(forecastLength).fill(0), statisticalForecast: new Array(forecastLength).fill(0) };

            const pmForecast = brand.forecast.value.pmForecast,
                statisticalForecast = brand.forecast.value.statisticalForecast;

            for (let sku of brand.skus) {

                if (!angular.isArray(sku.forecast.pmForecast) || !angular.isArray(sku.forecast.price))
                    continue;
                for (let i = 0; i < forecastLength; ++i) {
                    let offset = sku.forecast.price.length - forecastLength + i;
                    pmForecast[i] += sku.forecast.price[offset] * sku.forecast.pmForecast[i];
                    statisticalForecast[i] += sku.forecast.price[offset] * sku.forecast.statisticalForecast[i];
                }
            }
            synchronousEventsBus.$broadcast('sku.BrandValueCalculated', {
                brand,
                forecast: forecastCacheService.getForecast().market.forecast,
                parameters: forecastCacheService.getForecast().parameters
            });
        }

        service.calculateBrandVolumeBySkuChanges = (brand: $TSFixMe) => {

            let forecastLength = brand.forecast.value.pmForecast.length;
            brand.forecast.volume = { pmForecast: new Array(forecastLength).fill(0), statisticalForecast: new Array(forecastLength).fill(0) };

            const pmForecast = brand.forecast.volume.pmForecast,
                statisticalForecast = brand.forecast.volume.statisticalForecast;

            for (let sku of brand.skus) {
                for (let i = 0; i < forecastLength; ++i) {
                    let offset = sku.forecast.price.length - forecastLength + i;
                    pmForecast[i] += sku.forecast.pmForecast[i] / sku.forecast.price[offset];
                    statisticalForecast[i] += sku.forecast.statisticalForecast[i] / sku.forecast.price[offset];
                }
            }

        }



        service.onSkuValueChange = (e: $TSFixMe, args: $TSFixMe) => {
            const brand = args.brand;
            for (let sku of brand.skus) {
                if (sku.forecast.pmForecast) {
                    if (args.parameters.forecastType.typeId == 'value') {
                        sku.forecast.volume = { pmForecast: [], statisticalForecast: [] }
                    }
                    else if (args.parameters.forecastType.typeId == 'volume') {
                        sku.forecast.value = { pmForecast: [], statisticalForecast: [] }
                    }

                    for (let index = 0; index < sku.forecast.pmForecast.length; ++index) {
                        if (args.parameters.forecastType.typeId == 'value') {
                            sku.forecast.volume.pmForecast[index] = sku.forecast.price[index] == 0 ? 0 : sku.forecast.pmForecast[index] / sku.forecast.price[index];
                            sku.forecast.volume.statisticalForecast[index] = sku.forecast.price[index] == 0 ? 0 : sku.forecast.statisticalForecast[index] / sku.forecast.price[index];
                        } else if (args.parameters.forecastType.typeId == 'volume') {
                            sku.forecast.value.pmForecast[index] = sku.forecast.pmForecast[index] * sku.forecast.price[index];
                            sku.forecast.value.statisticalForecast[index] = sku.forecast.statisticalForecast[index] * sku.forecast.price[index];
                        }

                    }
                }
            }

            synchronousEventsBus.$broadcast('sku.skuValueCalculated', args);
        }

        service.skuPriceChanged = (parameters: $TSFixMe, brand: $TSFixMe, skuSorecast: $TSFixMe) => {
            return synchronousEventsBus.$broadcast('sku.skuValueChanged', { brand, parameters });
        }


        service.registerEvents = () => {
            synchronousEventsBus.$on('pmForecastChanged', service.onRegressionChange);
            synchronousEventsBus.$on('sku.skuValueChanged', service.onSkuValueChange);
            synchronousEventsBus.$on('sku.SkuVolumeCalculated', service.onSkuValueChange);
            synchronousEventsBus.$on('sku.skuValueCalculated', (e: $TSFixMe, args: $TSFixMe) => {
                if (args.parameters.forecastType.typeId == 'volume') {
                    service.calculateBrandValueBySkuChanges(args.brand);
                } else if (args.parameters.forecastType.typeId == 'value') {
                    service.calculateBrandVolumeBySkuChanges(args.brand);
                }
            });
        };

    }

    module.run(['skuVolumeValueService', (service: $TSFixMe) => { service.registerEvents(); }]);


})(angular.module('topline.services'));